import { DecentralizationGroupsService } from "../services/decentralization/decentralization.service";
import { store } from "../store/store";

export const SET_ADMIN_USER = "SET_ADMIN_USER";

export const fetchAdminUser = async (userId: any) => {
  if (!userId) return;
  const res = await DecentralizationGroupsService.getGroupOfUser(userId);
  store.dispatch(setAdminUser(res.length > 0 ? res[0] : null));
};

export const setAdminUser = (data: any) => {
  return {
    type: SET_ADMIN_USER,
    data,
  };
};
